import type { FaireProductEntity } from "../../entity_types/product";

export const p_efa5ksyg38: FaireProductEntity = {
  token: "p_efa5ksyg38",
  type: "product",
  name: "Irregular Wide Acrylic Simple Bracelets DP25B586",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/60f2da9833aa2f702e166856f0c1776c904d932294598ba1c82de567c3d79d83.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0dbc9af4da113a4c3542200286e772ebce11c22da7cc8677054334ce4bf0251f.jpeg",
    "https://cdn.faire.com/fastly/bdbb029d4a10c95c47572e4071ebaabe2f508b25e6e57a7d8d4026ff90ed2604.jpeg",
    "https://cdn.faire.com/fastly/aa3aeb628c210572181b355f6e43652c6fbeefe10f7c79cc6b92a7eb280762d9.jpeg",
    "https://cdn.faire.com/fastly/3a6b20923b9a10bde67851d8bd77a504650680cf07c7ed15b09edbfa247e27ec.jpeg",
    "https://cdn.faire.com/fastly/b493627622b646789d9804f092355b6579678aee5f8cb953c37847cb2da180b0.jpeg",
    "https://cdn.faire.com/fastly/105a3d0ebc30c8d2c4ed1e3b52886ecea04548afcaef68f7021f3bb83f33e4da.jpeg",
    "https://cdn.faire.com/fastly/63f0204a187dcfd7747b997d8322a1d08b558ea22976ac83ce6a4646b04a6e49.jpeg",
  ],
  priceDollars: 6.36,
  description:
    "Feature:\n * Irregular \n * Wide Style\n * Layered Wear\n * Marbling Patterns\n * Smooth Surface\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 80g\n\n Material:\n * Acrylic\n\n Package:\n * Package include 1 bracelet.\n\n Note:\n * Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n * Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product.",
  tags: [],
  msrpDollars: 12.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:31.301Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
